<template>
  <main>
    <Date />
    <Sponsor />
  </main>
</template>

<script>
const Date = () => import('@/components/Date/Main')
const Sponsor = () => import('@/components/Sponsor/Main')

export default {
  components: {
    Date,
    Sponsor
  }
}
</script>
